import { render, staticRenderFns } from "./PrivacyMix2Word.vue?vue&type=template&id=358474c3&scoped=true"
import script from "./PrivacyMix2Word.vue?vue&type=script&lang=js"
export * from "./PrivacyMix2Word.vue?vue&type=script&lang=js"
import style0 from "./PrivacyMix2Word.vue?vue&type=style&index=0&id=358474c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358474c3",
  null
  
)

export default component.exports